export default import.meta.ROLLDOWN_FILE_URL_B4nrLc9ZkbZFRLy5fRf0IQ